// ============================================
// CONFIGURAZIONE CONTATTI — Sito Ufficiale Maria Fasanella
// ============================================
export const WHATSAPP_NUMBER = "393396451538";

export const waLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MESSAGE =
    "Ciao Maria, ho visto il tuo sito e vorrei informazioni sulle tue consulenze e opportunità AI!";

export const IMAGES = {
    portrait: "/maria-fasanella.jpg",
    portraitCard: "/maria-card.jpg",
    aiWave:
        "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwZGlnaXRhbCUyMHRlY2hub2xvZ3klMjBhenVyZSUyMGFic3RyYWN0fGVufDB8fHx8MTc5MjU3MzQzMnww&ixlib=rb-4.1.0&q=85",
    aiBrain:
        "https://images.unsplash.com/photo-1753513291124-4f615bf1f6de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwZGlnaXRhbCUyMHRlY2hub2xvZ3klMjBhenVyZSUyMGFic3RyYWN0fGVufDB8fHx8MTc5MjU3MzQzMnww&ixlib=rb-4.1.0&q=85",
    creatorStudio:
        "https://images.unsplash.com/photo-1673767297241-f072cfefa0cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxjb250ZW50JTIwY3JlYXRvciUyMHN0dWRpbyUyMGxhcHRvcCUyMEFJJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3OTI1NzM0MzJ8MA&ixlib=rb-4.1.0&q=85",
};
